import { Form, Button, Col, Row, Card, InputGroup, Tooltip, OverlayTrigger, Table, Modal } from 'react-bootstrap';
import { FaEdit, FaInfoCircle, FaTrash } from 'react-icons/fa';
import Amount from '../../core/Amount';
import React, { useState, useEffect } from 'react';
import InfoTooltip from '../../core/ToolTip';
import axios from "axios";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { SpinnerModal, blockInvalidAmount, generateYears } from '../Util';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';



export default function FiscalResponse() {
    const navigate = useNavigate();
    //const history = useHistory();
    const years = generateYears(2020, new Date().getFullYear());

    const FISCAL_BASE_URL = process.env.REACT_APP_FISCAL_BASE_URL;
    const FISCAL_POST = process.env.REACT_APP_FISCAL_POST;
    const FISCAL_PUT = process.env.REACT_APP_FISCAL_PUT;
    const FISCAL_GET_ID = process.env.REACT_APP_FISCAL_GET_ID;


    const data = {
        type: "FISCAL",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        rentals: {
            freeRental: "",
            totalNoOfRentals: 0,
            totalNoOfPeople: 0,
            rentalCategories: [],
            totalRentalRevenue: "",
            rentalPhmcSplit: "",
            rentalAssociateSplit: "",
            phmcRevenueShare: "",
            associateRevenueShare: ""

        },
        membership: {
            noOfMembership: "",
            revenue: "",
            remarks: ""
        },
        event: {
            surcharges: "",
            fundraisers: "",
            donationsContributions: "",
            sponsorships: "",
            honoraria: "",
            corpus: "",
            interestDividends: "",
            otherInterest: "",
            grantsPHMC: "",
            operationSite: "",
            otherPurpose: "",
            fundsJointProjects: "",
            legIntiativeGrants: "",
            miscellaneous: "",
            total: ""
        },
        assets: {
            fundsJointProjects: "",
            capitolAssets: "",
            cashBalanceOrReserve: "",
            total: ""
        },
        contributions: {
            cashValueOfProgram: "",
            contributedMaterials: "",
            contributedService: "",
            total: ""
        },
        expenditures: {},
        museumStore: {}

    }

    const [rentalCategoriesData, setRentalCategoriesData] = useState([]);
    const rentalCategories = {
        type: "",
        noOfRentals: "",
        noOfPeople: ""
    }

    const rentalSchema = Yup.object({
        type: Yup.string().required('Category is required'),
        noOfRentals: Yup.number().required('Number of Rentals is required')
            .positive('Number must be positive')
            .integer('Decimal values are not allowed'),
        noOfPeople: Yup.number().required('Number of People is required')
            .positive('Number must be positive')
            .integer('Decimal values are not allowed')
    });

    const rentalForm = useFormik({
        initialValues: rentalCategories,
        initialTouched: {
            category: true,
            noOfRentals: true,
            noOfPeople: true
        },
        validationSchema: rentalSchema,
        onClick: (values) => {

        }
    });
    const handleRentalCategoryRecord = () => {
        console.log('add clicked : ' + rentalForm.touched.category);
        rentalForm.validateForm().then(() => {
            console.log('errors:' + rentalForm.errors);
            if (Object.keys(rentalForm.errors).length === 0) {
                // If there are no validation errors, add the record
                console.log("Adding record:", rentalForm.values);
                setRentalCategoriesData((prevData) => [...prevData, rentalForm.values]);
                formData.rentals.rentalCategories = rentalCategoriesData;
                formData.rentals.totalNoOfRentals = formData.rentals.totalNoOfRentals + parseInt(rentalForm.values.noOfRentals);
                formData.rentals.totalNoOfPeople = formData.rentals.totalNoOfPeople + parseInt(rentalForm.values.noOfPeople);
                rentalForm.resetForm(); // Optionally reset the form after adding a record
            } else {
                console.log('error')
            }
        });
    };


    const [formData, setFormData] = useState(data);
    const [showValidationError, setShowValidationError] = useState(false);
    // Show , Hide alert after save/submit
    const [show, setShow] = useState(false);
    const [successId, setSuccessId] = useState('');
    // Alert message after save/submit
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pagePath, setPagePath] = useState('');

    let { id } = useParams();
    useEffect(() => {
        const recordId = id;
        console.log(recordId);
        if (recordId) {
            setSpinnerShow(true);
            const url = `${FISCAL_BASE_URL}${recordId}${FISCAL_GET_ID}`;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    setFormData(data);
                    setRentalCategoriesData(data.rentals.rentalCategories);
                    setSpinnerShow(false);
                })
        }
    }, []);



    const handleInputChange = (e) => {

        const { name, value } = e.target;
        console.log(`name: ${name}, value: ${value}`);
        const [group, ...keys] = name.split('.');

        if (keys.length >= 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];
            keys.forEach((key, index) => {
                console.log(key);
                if (index === keys.length - 1) {
                    currentLevel[key] = value;
                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }
                if (key === "rentalPhmcSplit") {
                    const totalRentalRevenue = parseFloat(formData.rentals.totalRentalRevenue) || 0;
                    const rentalAssociateSplit = (100 - value);
                    formData.rentals.rentalAssociateSplit = rentalAssociateSplit;
                    formData.rentals.phmcRevenueShare = (totalRentalRevenue * (value / 100)).toFixed(2);
                    formData.rentals.associateRevenueShare = (totalRentalRevenue * (rentalAssociateSplit / 100)).toFixed(2);
                }
            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });
        }


    };

    const handleNextToExpenditure = (e) => {
        navigate(`/expenditureResponse/${formData._id}`);

    }


    const [spinnerShow, setSpinnerShow] = useState(false);

    return (
        <>

            Fiscal - Revenue
            <div className="main-content">

                <Form className="main-content" onSubmit={handleNextToExpenditure}>
                    <Row className="main-content">

                        <Form.Group as={Col} controlId="siteName">
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select name="siteName" disabled value={formData.siteName} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select disabled name="year" value={formData.year} onChange={handleInputChange}>
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="month">
                            <Form.Label>Month</Form.Label>
                            <Form.Select name="month" disabled value={formData.month} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>
                    {/* Rentals */}

                    <Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Rentals</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="freeRental">
                                            <Form.Label>Free Rental</Form.Label>
                                            <Form.Check type="switch" id="custom-switch" label="Y/N" disabled name="rentals.freeRental" value={formData.rentals?.freeRental} onChange={(e) => { formData.rentals.freeRental = e.target.checked ? true : false }} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalNoOfRentals">
                                            <Form.Label>Total No of rentals</Form.Label>
                                            <Form.Control disabled name="rentals.totalNoOfRentals" value={formData.rentals?.totalNoOfRentals} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalNoOfPeople">
                                            <Form.Label>Total No of People</Form.Label>
                                            <Form.Control disabled name="rentals.totalNoOfPeople" value={formData.rentals?.totalNoOfPeople} />
                                        </Form.Group>
                                    </Row>


                                    <Row className="mb-3 main-content" >
                                        <Table bordered striped hover >
                                            <thead>
                                                <tr>
                                                    <th>Category</th>
                                                    <th>No of Rentals</th>
                                                    <th>No of People </th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Form.Group as={Col} controlId="type">
                                                            <Form.Select name="type" disabled value={rentalForm.values.type}
                                                                onChange={rentalForm.handleChange}
                                                                isInvalid={rentalForm.touched.type && rentalForm.errors.type}>
                                                                <option value="">Select</option>
                                                                <option>Business Meeting/Conference</option>
                                                                <option>Wedding</option>
                                                                <option>Reception</option>
                                                                <option>Birthday</option>
                                                                <option>Reunion</option>
                                                                <option>Filming Event</option>
                                                                <option>Other</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type='invalid'>
                                                                {rentalForm.touched.type && rentalForm.errors.type}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group as={Col} controlId="noOfRentals">
                                                            <Form.Control type="number" name="noOfRentals" disabled value={rentalForm.values.noOfRentals}
                                                                onChange={rentalForm.handleChange}
                                                                isInvalid={rentalForm.touched.noOfRentals && rentalForm.errors.noOfRentals} />

                                                            <Form.Control.Feedback type='invalid'>
                                                                {rentalForm.touched.noOfRentals && rentalForm.errors.noOfRentals}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control name="noOfPeople" type="number" disabled value={rentalForm.noOfPeople}
                                                                onChange={rentalForm.handleChange}
                                                                isInvalid={rentalForm.touched.noOfPeople && rentalForm.errors.noOfPeople} />
                                                            <Form.Control.Feedback type='invalid'>
                                                                {rentalForm.touched.noOfPeople && rentalForm.errors.noOfPeople}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </td>
                                                    <td><Button variant="primary" disabled={!rentalForm.dirty} onClick={handleRentalCategoryRecord}> +</Button></td>
                                                </tr>
                                                {
                                                    rentalCategoriesData.map((input, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{input.type}</td>
                                                                <td>{input.noOfRentals}</td>
                                                                <td>{input.noOfPeople}</td>
                                                                <td ><Button variant="transparent" > <FaEdit /></Button>
                                                                    <Button variant="transparent" > <FaTrash /></Button></td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody></Table>
                                    </Row>

                                    <Row className="mb-3 main-content" >
                                        <Amount as={Col} label="Total Rental Revenue" name="rentals.totalRentalRevenue" disabled value={formData.rentals?.totalRentalRevenue} onChange={handleInputChange} />
                                        <Form.Group as={Col}>
                                            <Form.Label>PHMC Revenue Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control name="rentals.rentalPhmcSplit" type="number" disabled value={formData.rentals?.rentalPhmcSplit}
                                                    onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>Associate Revenue Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control disabled name="rentals.rentalAssociateSplit" value={formData.rentals?.rentalAssociateSplit} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3 main-content" >
                                        <Amount as={Col} disabled label="PHMC Revenue Share" name="rentals.phmcRevenueShare" value={formData.rentals?.phmcRevenueShare} onChange={handleInputChange} />
                                        <Amount as={Col} disabled label="Associate Revenue Share" name="rentals.associateRevenueShare" value={formData.rentals?.associateRevenueShare} onChange={handleInputChange} />
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>



                    {/* Membership */}

                    <Row className="mb-3 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Membership</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="noOfMemebership">
                                            <Form.Label>No of Memberships</Form.Label>
                                            <Form.Control type="number" disabled
                                                name="membership.noOfMembership"
                                                value={formData.membership?.noOfMembership}
                                                placeholder='0'
                                                aria-label="No of Memberships"
                                                onChange={handleInputChange}


                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid membership number.
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Amount as={Col} label="Membership Revenue" disabled name="membership.revenue" value={formData.membership?.revenue} onChange={handleInputChange} />
                                        <Form.Group as={Col} controlId="revenue">
                                            <InfoTooltip label={'Membership Price Points'} placement={"right"}  >
                                                <Form.Label> Remarks <FaInfoCircle /></Form.Label>
                                            </InfoTooltip>
                                            <InputGroup>
                                                <Form.Control as="textarea" name="membership.remarks" disabled value={formData.membership?.remarks} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>

                    {/* Event Fiscal Entry */}
                    <Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    {/*              <Card.Title>Event Information</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Money's Collected</Card.Title>
                                                <Row className="mb-0 main-content">
                                                    <Form.Group as={Col} controlId="formGridAddress2">
                                                        <Form.Label>Event Name</Form.Label>
                                                        <Form.Select defaultValue="Choose...">
                                                            <option>Select</option>
                                                            <option>Reading Railroad Days</option>
                                                            <option>Barons & Builders Day Camps</option>
                                                            <option>Model Railroad Days </option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridAddress2">
                                                        <Form.Label>No of Attendees</Form.Label>
                                                        <Form.Control type="number" required placeholder="0" />
                                                    </Form.Group>

                                                    <Amount as={Col} label="Totals" />
                                                </Row>

                                            </Card.Body>
                                        </Card>
                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Other Non-Event</Card.Title>
                                                <Row className="mb-0 main-content">
                                                    <Form.Group as={Col} controlId="formGridAddress2">
                                                        <Form.Label>Event Name</Form.Label>
                                                        <Form.Select defaultValue="Choose...">
                                                            <option>Select</option>
                                                            <option>Rambles</option>
                                                            <option>Supplemental Visitor Services</option>
                                                            <option>Facility Use Rentals</option>
                                                            <option>Motorcoach</option>
                                                            <option>Fees & Tours</option>
                                                            <option>School Tours</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formGridAddress2">
                                                        <Form.Label>No of Attendees</Form.Label>
                                                        <Form.Control type="number" required placeholder="0" />
                                                    </Form.Group>
                                                    <Amount as={Col} label="Totals" />
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Row> */}
                                    <Row className="mb-0 main-content" >
                                        <Amount as={Col} label="Surcharges" name="event.surcharges" disabled value={formData.event?.surcharges} onChange={handleInputChange} />
                                        <Amount as={Col} label="Fundraisers" name="event.fundraisers" disabled value={formData.event?.fundraisers} onChange={handleInputChange} />
                                        <Amount as={Col} label="Cash Donations/Contributions" name="event.donationsContributions" disabled value={formData.event?.donationsContributions} onChange={handleInputChange} />
                                        <Amount as={Col} label="Sponsorships" name="event.sponsorships" disabled value={formData.event?.sponsorships} onChange={handleInputChange} />
                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Amount as={Col} label="Honoraria" name="event.honoraria" disabled value={formData.event?.honoraria} onChange={handleInputChange} />
                                        <Amount as={Col} label="Endowments and Trust Funds - Corpus" name="event.corpus" disabled value={formData.event?.corpus} onChange={handleInputChange} />
                                        <Amount as={Col} label="Endowments and Trust Funds - Interest and Dividends" disabled name="event.interestDividends" value={formData.event?.interestDividends} onChange={handleInputChange} />
                                        <Amount as={Col} label="Other Interest" name="event.otherInterest" disabled value={formData.event?.otherInterest} onChange={handleInputChange} />

                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Amount as={Col} label="Grants from PHMC" name="event.grantsPHMC" disabled value={formData.event?.grantsPHMC} onChange={handleInputChange} />
                                        <Amount as={Col} label="Operation of Site" name="event.operationSite" disabled value={formData.event?.operationSite} onChange={handleInputChange} />
                                        <Amount as={Col} label="Other Purposes" name="event.otherPurpose" disabled value={formData.event?.otherPurpose} onChange={handleInputChange} />
                                        <Amount as={Col} label="Funds for Joint Projects" name="event.fundsJointProjects" disabled value={formData.event?.fundsJointProjects} onChange={handleInputChange} />
                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Amount as={Col} label="Legislative Initiatives & Grants" name="event.legIntiativeGrants" disabled value={formData.event?.legIntiativeGrants} onChange={handleInputChange} />
                                        <Amount as={Col} label="Miscellaneous" name="event.miscellaneous" disabled value={formData.event?.miscellaneous} onChange={handleInputChange} />
                                        <Amount as={Col} label="Total" name="event.total" disabled value={formData.event?.total} onChange={handleInputChange} />
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col >

                    </Row >

                    {/* Assets*/}
                    < Row className="main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Assets</Card.Title>
                                    <Row className="main-content" >
                                        <Amount as={Col} label="Total Value Endowments and Trust Funds" disabled name="assets.fundsJointProjects" value={formData.assets?.fundsJointProjects} onChange={handleInputChange} />
                                        <Amount as={Col} label="Capitol Assets" name="assets.capitolAssets" disabled value={formData.assets?.capitolAssets} onChange={handleInputChange} />

                                    </Row>
                                    <Row className="main-content" >
                                        {/* TODO: Need to confirm from PHMC  */}
                                        {/* <Amount as={Col} label="Other - Gift Shop Inventory" /> */}
                                        <Amount as={Col} label="End of Year Cash Balance/Reserve" disabled name="assets.cashBalanceOrReserve" value={formData.assets?.cashBalanceOrReserve} onChange={handleInputChange} />
                                        <Amount as={Col} disabled label="Total" name="assets.total" value={formData.assets?.total} onChange={handleInputChange} />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            {/* Contributions */}
                            <Card>
                                <Card.Body>
                                    <Card.Title><strong>Contributions</strong></Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="cashValueOfProgram">
                                            <Form.Label>Cash Value of Programs</Form.Label>
                                            <Form.Select defaultValue="Choose..." name="contributions.cashValueOfProgram" disabled value={formData.contributions?.cashValueOfProgram} onChange={handleInputChange} >
                                                <option>Select</option>
                                                <option>Scholars in Residence</option>
                                                <option>Intern/PHEAA</option>
                                                <option>Green Thumb</option>
                                                <option>Other</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Amount as={Col} label="Cash Value of Contributed Materials" disabled name="contributions.contributedMaterials" value={formData.contributions?.contributedMaterials} onChange={handleInputChange} />
                                    </Row>
                                    <Row className="main-content" >
                                        <Amount as={Col} label="Cash Value of Contributed Services (inc. rentals)" disabled name="contributions.contributedService" value={formData.contributions?.contributedService} onChange={handleInputChange} />
                                        <Amount as={Col} disabled label="Total" name="contributions.total" value={formData.contributions?.total} />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row >



                    <Row className="mb-3 main-content">

                        <Col>
                            <Row className="mb-3 submit">
                                <Col>

                                    <Button variant="primary" name="submit" type="submit" >
                                        Next
                                    </Button>

                                </Col>
                            </Row>
                        </Col>


                        <Col />
                        <Col />
                        <Col />
                    </Row>


                </Form >
                {/* )}
            </Formik>  */}

            </div >
        </>
    );
}